/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._flex_dkj4c_157 {
  display: flex;
}

._justify-content-space-between_dkj4c_161 {
  justify-content: space-between;
}

._tabular-nums_dkj4c_165 {
  font-variant-numeric: tabular-nums;
}

@keyframes _show_dkj4c_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Text styles */
:root {
  --primary: #167cf4;
  --primary-40: #3d73d7;
  --primary-10: #e6f7ff;
  --secondary: #f58984;
  --secondary-40: #fcbbae;
  --secondary-10: #fef0ed;
  --bay-grey: #989ea8;
  --grey-10: #fafafa;
  --grey-25: #e9e8ea;
  --grey-50: #aeaeae;
  --grey-75: #8f8f8f;
  --grey-100: #1a1b1c;
  --white: #fff;
  --black: #1a1b1c;
  --green: #006462;
  --sand: #f6f3ef;
  --yellow: #ffcd5b;
  --magenta-base: #ffddff;
  --red-base: #f5b3b4;
  --volcano-base: #ff9c93;
  --orange-base: #fabf95;
  --gold-base: #f1e5ac;
  --lime-base: #ebffd0;
  --sage-base: #c1e1c1;
  --cyan-base: #c9f2f2;
  --blue-base: #70d1f1;
  --geekblue-base: #a2aff1;
  --purple-base: #c5b3e3;
  --mauve-base: #c6b0ca;
  --coral-base: #ff8a8a;
  --apricot-base: #f5a287;
  --marigold-base: #fdaf1c;
  --butter-base: #f9eda1;
  --apple-base: #b7d275;
  --asparagus-base: #9db17c;
  --tiffany-base: #5fcdca;
  --baby-base: #a3ddf9;
  --carolina-base: #7eb3d8;
  --rose-base: #ffb4c7;
  --watermelon-base: #ffa1b6;
  --blue-0: #f4fcff;
  --blue-1: #e6f7ff;
  --blue-3: #91d5ff;
  --blue-5: #499dff;
  --blue-6: #167cf4;
  --blue-7: #2771c9;
  --gray-1: #fff;
  --gray-2: #fafafa;
  --gray-3: #f5f5f5;
  --gray-4: #f0f0f0;
  --gray-5: #d9d9d9;
  --gray-6: #bfbfbf;
  --gray-7: #8c8c8c;
  --gray-8: #505256;
  --gray-9: #1f1f21;
  --red-1: #fff1f0;
  --red-3: #ffa39e;
  --red-4: #ff7875;
  --red-5: #ff4d4f;
  --red-6: #f5222d;
  --gold-1: #fffbe6;
  --gold-3: #ffe58f;
  --gold-5: #ffc53d;
  --gold-6: #faad14;
  --gold-7: #d48806;
  --green-1: #f6ffed;
  --green-3: #b7eb8f;
  --green-5: #73d13d;
  --green-6: #52c41a;
  --green-7: #389e0d;
  --text-color: #505256;
  --text-color-secondary: #8c8c8c;
  --text-color-inverse: #fff;
  --icon-color: inherit;
  --icon-color-hover: rgba(26, 27, 28, 0.75);
  --heading-color: #1f1f21;
  --text-color-dark: rgba(255, 255, 255, 0.85);
  --text-color-secondary-dark: rgba(255, 255, 255, 0.65);
  --text-selection-bg: #167cf4;
  --link-color: #167cf4;
  --modal-mask-bg: rgba(79, 90, 114, 0.45);
}

._nodeDecorator_dkj4c_346 {
  width: 2rem;
  align-self: stretch;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  background: #1E4945;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  display: flex;
}
._nodeDecorator_dkj4c_346 ._actionNodeIcon_dkj4c_359 {
  color: #BDD7C8;
}
._nodeDecorator_dkj4c_346 ._conditionNodeIcon_dkj4c_362 {
  color: #F5D9D3;
}
._nodeDecorator_dkj4c_346 ._delayNodeIcon_dkj4c_365 {
  color: #D3F1F5;
}
._nodeDecorator_dkj4c_346 ._triggerNodeIcon_dkj4c_368 {
  color: #E3F1BB;
}

._nodeContent_dkj4c_372 {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
._nodeContent_dkj4c_372 .ant-tag {
  cursor: pointer;
}
._nodeContent_dkj4c_372 ._nodeTag_dkj4c_382 {
  width: fit-content;
  max-width: 17.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
._nodeContent_dkj4c_372 ._actionContent_dkj4c_388 {
  display: flex;
  align-items: center;
  column-gap: 0.4375rem;
}
._nodeContent_dkj4c_372 ._actionContent_dkj4c_388 ._actionNodeTag_dkj4c_393 {
  max-width: 15.625rem;
  padding: 0.5rem;
}
._nodeContent_dkj4c_372 ._actionContent_dkj4c_388 ._actionNodeTag_dkj4c_393 ._actionContent_dkj4c_388 {
  display: flex;
  align-items: center;
  column-gap: 0.3125rem;
}
._nodeContent_dkj4c_372 ._actionContent_dkj4c_388 ._actionNodeTag_dkj4c_393 ._actionContent_dkj4c_388 ._actionResource_dkj4c_402 {
  overflow: hidden;
}
._nodeContent_dkj4c_372 ._actionContent_dkj4c_388 ._actionNodeTag_dkj4c_393 ._actionContent_dkj4c_388 ._actionResource_dkj4c_402 ._emailTemplate_dkj4c_405 {
  font-size: 0.875rem;
  font-weight: bold;
  color: #1f1f21;
  overflow: hidden;
  text-overflow: ellipsis;
}
._nodeContent_dkj4c_372 ._actionContent_dkj4c_388 ._actionNodeTag_dkj4c_393 ._actionContent_dkj4c_388 ._actionResource_dkj4c_402 ._resourceEmail_dkj4c_412 {
  overflow: hidden;
  text-overflow: ellipsis;
}
._nodeContent_dkj4c_372 ._actionContent_dkj4c_388 ._actionNodeTag_dkj4c_393 ._actionContent_dkj4c_388 ._actionResource_dkj4c_402 ._resourceEmail_dkj4c_412 ._attribute_dkj4c_416 {
  color: #8c8c8c;
}

._alert_dkj4c_420 {
  background: #fffbe6;
}